import { PrismaClient } from "@prisma/client"

const prisma = global.prisma || new PrismaClient({ datasourceUrl: process.env.DIRECT_DATABASE_URL })

if (process.env.NODE_ENV === 'development') global.prisma = prisma

export default prisma